import Vue from 'vue';
import VueHtmlToPaper from 'vue-print-nb';

Vue.use(VueHtmlToPaper);